import {
  Dialog,
  IconButton,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useForm } from 'react-hook-form';

import { FormProvider, RHFTextField, CustomAvatar } from '@app/components';
import { Strings } from '@app/constants';

interface Item {
  id: string;
  label: string;
  avatar?: string;
}

interface BoardFilterDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  items: Item[];
  onSelect: (item: Item) => void;
}

const BoardAssigneeFilterDialog = ({
  open,
  onClose,
  title,
  items,
  onSelect,
}: BoardFilterDialogProps) => {
  const methods = useForm({ defaultValues: { search: '' } });
  const search = methods.watch('search');

  const filteredItems = items.filter((item) =>
    item.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <FormProvider methods={methods}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" px={2} pt={2}>
          <Typography fontWeight="bold">{title}</Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
        <Stack>
          <RHFTextField
            name="search"
            placeholder={Strings.common.search}
            sx={{ p: 2 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
          />
        </Stack>
        <List>
          {filteredItems.map((item) => (
            <ListItem
              button
              key={item.id}
              onClick={() => {
                onSelect?.(item);
              }}
            >
              <ListItemAvatar>
                <CustomAvatar name={item.label} src={item.avatar} color="info" />
              </ListItemAvatar>
              <ListItemText primary={item.label} />
            </ListItem>
          ))}
        </List>
      </FormProvider>
    </Dialog>
  );
};
export { BoardAssigneeFilterDialog };
